import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import ChartEditMetaView from "../../meta";
import ChartEditForm from "./form";
import ChartNotesForm from "./notes";
import AnalyticsBehavior from "../../../../behaviors/analytics";
import templates from "../../../../utils/templates";

const channel = Radio.channel("global");

const DEFAULTS = {
  template: templates.find("chart_reviews", "chart_edit_chart_layout"),
};

class View extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);

    this.refreshModelOnActivation = false;
  }

  behaviors() {
    return [
      {
        behaviorClass: AnalyticsBehavior,
        opts: {
          title: this.options.title || null,
        },
      },
    ];
  }

  regions() {
    return {
      meta: ".chart-review-meta",
      form: ".chart-review-form > .body",
      notes: ".chart-review-notes > .card-body",
    };
  }

  childEvents() {
    return {
      "modal:close": "_hide",
    };
  }

  initialize() {
    this.listenTo(
      channel,
      "notify:model:out-of-date",
      this._onOutdatedModelNotification
    );
    this.listenTo(channel, "tab-activated", this._onActivate);
  }

  _onOutdatedModelNotification() {
    this.refreshModelOnActivation = true;
  }

  _onActivate(tab) {
    if ("tab-chart-edit" === tab) {
      if (this.refreshModelOnActivation) {
        this.model.fetch().then(() => {
          this.refreshModelOnActivation = false;
          // recreate notes panel
          this.notes.show(
            new ChartNotesForm({
              model: this.model,
            })
          );
        });
      }

      if (this.form.currentView) {
        this.form.currentView._notifyBehaviors();
      }
    }
  }

  onBeforeShow() {
    this.meta.show(
      new ChartEditMetaView({
        model: this.model,
        memberCategories: this.model.get("memberCategories"),
      })
    );

    this.form.show(
      new ChartEditForm({
        model: this.model,
        apiModel: this.options.apiModel || null,
        active: this.options.active,
      })
    );

    this.notes.show(
      new ChartNotesForm({
        model: this.model,
      })
    );
  }

  _hide() {
    // notify parent layout of this change
    this.triggerMethod("modal:close");
  }
}

export { View as default };
